import React from 'react'
import PropTypes from 'prop-types'
import isEmpty from 'lodash/isEmpty'
import { Field } from 'redux-form'
import PrivacyMessageCheckbox from './PrivacyMessageCheckbox'

const PrivacyMessageCheckboxArea = (props) => {

  const renderCheckboxes = () => {
    return props.config.checkboxes.map((checkbox, index) => {
      const errorClassName = props.errors[checkbox.name] ? 'error' : ''

      return (
        !isEmpty(checkbox.label) &&
        <Field
          key={index}
          className={errorClassName}
          component={PrivacyMessageCheckbox}
          name={checkbox.name}
          checkboxLabel={checkbox.label}
          themeColorHex={props.themeColorHex} />
      )
    })
  }

  return(
    <div>
      <div className='checkbox-area-label'>{props.config.label}</div>
      {renderCheckboxes()}
    </div>
  )
}

PrivacyMessageCheckboxArea.propTypes = {
  config: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  themeColorHex: PropTypes.string
}

export default PrivacyMessageCheckboxArea
